import React from 'react'
import styled from '@emotion/styled'
import { TitleBarButtons } from './TitleBarButtons'
import * as constants from 'view/styles/constants'
import { iconSet } from 'view/components/icons'

interface TitleBarProps {
  title: string
  window: fin.OpenFinWindow
}

const TitleBarContainer = styled.div`
  width: 100%;
  flex: 0 0 30px;
  display: flex;
  align-items: center;
  background-color: black;
  -webkit-user-select: none;
  -webkit-app-region: drag;
  padding: 4px 10px 4px 7px;
  z-index: ${constants.zIndexOpenfinTitleBar};
`

const Title = styled.div`
  flex: 1 1 auto;
  display: flex;

  svg {
    width: 24px;
    height: 23px;
    color: ${constants.CORE_PRIMARY_5};
  }
`

const TitleLogoText = styled.div<{ isProdAdmin: boolean }>`
  display: flex;
  align-items: center;
  margin-left: 8px;
  font-family: NEXWeb;
  color: ${props => (props.isProdAdmin ? constants.ACCENT_BAD : constants.CORE_PRIMARY)};
  font-size: 14px;
`

export const TitleBar: React.FunctionComponent<TitleBarProps> = props => {
  const { window, title } = props

  return (
    <TitleBarContainer>
      <Title>
        {__ENVCONFIG.isAdmin === 'true' ? iconSet.headerLogoIconAdmin : iconSet.headerLogoIcon}
        <TitleLogoText isProdAdmin={__ENVCONFIG.environmentName.toUpperCase() === 'PROD' && __ENVCONFIG.isAdmin === 'true'}>
          {title}
        </TitleLogoText>
      </Title>
      <TitleBarButtons window={window} />
    </TitleBarContainer>
  )
}
